"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var context_1 = require("../../../context");
var Button_1 = require("../../Button");
var Card_1 = require("../../Card");
var FormControl_1 = __importDefault(require("../../FormControl"));
var Grid_1 = require("../../Grid");
var Icon_1 = __importStar(require("../../Icon"));
var Input_1 = __importDefault(require("../../Input"));
var Select_1 = __importDefault(require("../../Select"));
var Tabs_1 = require("../../Tabs/Tabs");
var TextArea_1 = __importDefault(require("../../TextArea"));
var emptyDisability = {
    id: null,
    type: null,
    category: null,
    category_readable: null,
    info: null,
};
var DisabilitiesForm = function (_a) {
    var tabId = _a.tabId;
    var _b = context_1.useSemantics(), trans = _b.trans, options = _b.options;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var _c = formik_1.useFormikContext(), setValues = _c.setValues, values = _c.values, errors = _c.errors;
    var disabilities = values.disabilities || [emptyDisability];
    react_1.useEffect(function () { var _a; return setTabError(tabId, errors.disabilities ? ((_a = errors.disabilities) === null || _a === void 0 ? void 0 : _a.length) > 0 : false); }, [errors]);
    var addNewDisability = function () {
        setValues(__assign(__assign({}, values), { disabilities: __spreadArrays(disabilities, [emptyDisability]) }));
    };
    var removeDisability = function (index) {
        var newDisabilities = __spreadArrays(disabilities);
        newDisabilities.splice(index, 1);
        setValues(__assign(__assign({}, values), { disabilities: newDisabilities }));
    };
    return (react_1.default.createElement(Card_1.Card, { heading: trans('optiiva::headings.disabilities') },
        disabilities.map(function (disability, index) { return (react_1.default.createElement(react_1.default.Fragment, { key: "disability-" + index },
            react_1.default.createElement(Grid_1.Grid, null,
                react_1.default.createElement(Grid_1.GridColumn, { width: "w-1/2" },
                    react_1.default.createElement(FormControl_1.default, { errors: formik_1.getIn(errors, "disabilities." + index + ".category"), dusk: "disability-" + index + "-category", label: trans('optiiva::labels.category') },
                        react_1.default.createElement(Select_1.default, { name: "disabilities." + index + ".category", options: options.disabilityCategories() }))),
                react_1.default.createElement(Grid_1.GridColumn, { width: "w-1/2" },
                    react_1.default.createElement(FormControl_1.default, { errors: formik_1.getIn(errors, "disabilities." + index + ".type"), dusk: "disability-" + index + "-type", label: trans('optiiva::labels.type') },
                        react_1.default.createElement(Input_1.default, { name: "disabilities." + index + ".type" })))),
            react_1.default.createElement(FormControl_1.default, { flush: true, errors: formik_1.getIn(errors, "disabilities." + index + ".info"), dusk: "disability-" + index + "-info", label: trans('optiiva::labels.additional-info'), expand: true },
                react_1.default.createElement(TextArea_1.default, { name: "disabilities." + index + ".info" })),
            index > 0 && (react_1.default.createElement("div", { className: "mt-4" },
                react_1.default.createElement("button", { className: "inline-flex text-red text-sm", type: "button", onClick: function () { return removeDisability(index); } },
                    react_1.default.createElement(Icon_1.default, { name: Icon_1.IconIndex.DELETE }),
                    react_1.default.createElement("span", { className: "pl-2" }, trans('optiiva::labels.remove'))))),
            disabilities && disabilities.length - 1 > index && (react_1.default.createElement("div", { className: "border-b-3 border-gray-light my-8" })))); }),
        react_1.default.createElement("div", { className: "mt-4" },
            react_1.default.createElement(Button_1.WhiteButton, { className: "w-full", onClick: addNewDisability }, trans('optiiva::labels.add-disability')))));
};
exports.default = DisabilitiesForm;
//# sourceMappingURL=DisabilitiesForm.js.map